import { render, staticRenderFns } from "./projectDetail.vue?vue&type=template&id=d9c2fbf4&scoped=true"
import script from "./projectDetail.vue?vue&type=script&lang=ts"
export * from "./projectDetail.vue?vue&type=script&lang=ts"
import style0 from "./projectDetail.vue?vue&type=style&index=0&id=d9c2fbf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_3bbe12a2a332147dfeceaba3e069e538/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c2fbf4",
  null
  
)

export default component.exports